module.exports = __webpack_public_path__ + "static/media/client-landing-2.909240ee.jpg";